import { SvgIconProps } from '@mui/material'
import React from 'react'

const Complete: React.FC<SvgIconProps> = (props) => {
  return (
    <svg
      width={96}
      height={96}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx={48} cy={48} r={48} fill='#EAFFEA' />
      <g clipPath='url(#clip0_5057_207794)'>
        <path
          d='M39.0312 47.0703C34.088 47.0703 30.0664 51.0919 30.0664 56.0352C30.0664 60.9784 34.088 65 39.0312 65C43.9745 65 47.9961 60.9784 47.9961 56.0352C47.9961 51.0919 43.9745 47.0703 39.0312 47.0703ZM42.9895 54.9465L38.341 59.5949C38.1466 59.7894 37.8917 59.8867 37.6367 59.8867C37.3818 59.8867 37.1269 59.7894 36.9324 59.5949L34.9402 57.6027C34.5512 57.2138 34.5512 56.5831 34.9402 56.1941C35.3292 55.8051 35.9599 55.8051 36.3489 56.1941L37.6367 57.4819L41.5809 53.5378C41.9698 53.1489 42.6005 53.1489 42.9895 53.5378C43.3785 53.9268 43.3785 54.5575 42.9895 54.9465Z'
          fill='#0E9724'
        />
        <path
          d='M56.2969 39.6328C55.7468 39.6328 55.3008 39.1868 55.3008 38.6367V31H41.0234C39.3757 31 38.0352 32.3405 38.0352 33.9883V45.1239C38.3633 45.0941 38.6954 45.0781 39.0312 45.0781C42.4265 45.0781 45.4658 46.6304 47.4772 49.0625H58.2891C58.8392 49.0625 59.2852 49.5085 59.2852 50.0586C59.2852 50.6087 58.8392 51.0547 58.2891 51.0547H48.7895C49.4121 52.2697 49.8136 53.6156 49.9425 55.0391H58.2891C58.8392 55.0391 59.2852 55.485 59.2852 56.0352C59.2852 56.5853 58.8392 57.0312 58.2891 57.0312H49.9425C49.6446 60.3209 47.887 63.1955 45.3238 65H60.9453C62.5931 65 63.9336 63.6595 63.9336 62.0117V39.6328H56.2969ZM58.2891 45.0781H43.6797C43.1296 45.0781 42.6836 44.6321 42.6836 44.082C42.6836 43.5319 43.1296 43.0859 43.6797 43.0859H58.2891C58.8392 43.0859 59.2852 43.5319 59.2852 44.082C59.2852 44.6321 58.8392 45.0781 58.2891 45.0781Z'
          fill='#0E9724'
        />
        <path d='M57.293 31.5833V37.6406H63.3499L57.293 31.5833Z' fill='#0E9724' />
      </g>
      <defs>
        <clipPath id='clip0_5057_207794'>
          <rect width={34} height={34} fill='white' transform='translate(30 31)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Complete
